import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-file-list",
  "use": "icon-icon-file-list-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon-file-list\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><rect stroke=\"currentColor\" stroke-width=\"2\" x=\"2\" y=\"2\" width=\"12\" height=\"12\" rx=\"1\" /><rect fill=\"currentColor\" x=\"5\" y=\"5\" width=\"6\" height=\"2\" rx=\"1\" /><rect fill=\"currentColor\" x=\"5\" y=\"9\" width=\"6\" height=\"2\" rx=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol